import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import IsoCodeSelectList from '../../global/IsoCodeSelectList';
import {useUpdateParcelMutation} from '../../../redux/rtk/injectedParcelApi';
import {showMessageOnError, showMessageOnSuccess} from '../../global/CustomToast';
import {Parcel} from '../../functions/GlobalData';

type Props = {
    formId: string,
    projectId: string,
    selection: Parcel[],
    onFinished: () => void
}
export const ParcelEditSelectionForm = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common', 'stammdaten']);

    const [updateParcel] = useUpdateParcelMutation();
    const [data, setData] = useState<Parcel | undefined>(undefined);

    const defaultValues = {
        // 'flstkennz': '',
        // 'amtsgericht': '',
        // 'grundbuchbezirk': '',
        // 'gbbz': '',
        // 'blatt': '',
        // 'lfdnrbestandsvz': 0,
        // 'buchungsart': '',
        'b_land_iso': '',
        // 'zeitstempel': '',
        // 'kommentar': '',
        // 'ersteller': ''
    };

    const {control, formState: {errors}, handleSubmit, setValue, getValues, reset} = useForm({defaultValues});
    const saveData = (data: any) => {
        // eslint-disable-next-line camelcase
        setData(data);
    };

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] && <small className="p-error custom">{errors[name].message}</small>;
    };

    useEffect(() => {
        const aFunction = async () => {
            if (data) {
                let allOk = true;
                for (let i = 0; i < props.selection.length; i++) {
                    if (!allOk) {
                        break;
                    }

                    let item = props.selection[i];

                    await updateParcel({
                        project_id: props.projectId,
                        flurstueck_id: item.flurstueck_id,
                        flstkennz: item.flstkennz,
                        b_land_iso: data.b_land_iso,
                        common_data: true
                    }).then(async (result: any) => {
                        if (result.error) {
                            allOk = false;
                        }
                    });
                }

                if (allOk) {
                    showMessageOnSuccess(t('globalData:global.parcelUpdated'), '');
                    props.onFinished();
                }
            }
        };
        aFunction();
    }, [data]);

    return (
        <form id={props.formId} onSubmit={handleSubmit(saveData)}>
            <h4>{t('globalData:global.generalData')}</h4>
            <div className={'h-full w-full'}>
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.flstkennz')} name={'flstkennz'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: t('globalData:parcels.flstkennz') + ' ' + t('input:required')}}*/}
                {/*/>*/}
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.amtsgericht')} name={'amtsgericht'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: t('globalData:parcels.amtsgericht') + ' ' + t('input:required')}}*/}
                {/*/>*/}
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.grundbuchbezirk')}*/}
                {/*    name={'grundbuchbezirk'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: t('globalData:parcels.grundbuchbezirk') + ' ' + t('input:required')}}*/}
                {/*/>*/}
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.gbbz')} name={'gbbz'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: t('globalData:parcels.gbbz') + ' ' + t('input:required')}}*/}
                {/*/>*/}
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.blatt')} name={'blatt'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: t('globalData:parcels.blatt') + ' ' + t('input:required')}}*/}
                {/*/>*/}
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.lfdnrbestandsvz')}*/}
                {/*    name={'lfdnrbestandsvz'}*/}
                {/*    type={'number'}*/}
                {/*    value={getValues('lfdnrbestandsvz')}*/}
                {/*    onChange={(e: any) => {*/}
                {/*        setValue('lfdnrbestandsvz', e);*/}
                {/*    }}*/}
                {/*    max={32766}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{*/}
                {/*        required: t('globalData:parcels.lfdnrbestandsvz') + ' ' + t('input:required'),*/}
                {/*    }}*/}
                {/*/>*/}
                <IsoCodeSelectList
                    name={'b_land_iso'}
                    label={t('globalData:parcels.stateIso')}
                    validationControl={control}
                    validationErrorMessage={getFormErrorMessage}
                    validationRules={{required: false}}/>
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:parcels.buchungsart')} name={'buchungsart'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: t('globalData:parcels.buchungsart') + ' ' + t('input:required')}}*/}
                {/*/>*/}
                {/*<Input*/}
                {/*    edit={true} label={t('globalData:columns.comment')} name={'kommentar'}*/}
                {/*    validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                {/*    validationRules={{required: false}}*/}
                {/*/>*/}
            </div>
        </form>);
};
